import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import numeral from 'numeral';
import DropDownList from './DropDownList';

import ResultBar from '../components/ResultBar';

import { getUIText } from '../utils/index';

import { formatDecimalsW, formatDecimalsWperArea, formatDecimalsWperLength } from '../utils/calculations-helper';

import { CALCULATION_TYPE_PLANE, CALCULATION_TYPE_PIPE, CALCULATION_TYPE_DUCT, CALCULATION_TYPE_CIRCULAR_DUCT, CALCULATION_TYPE_RECTANGULAR_DUCT, CALCULATION_TYPE_VERTICAL_TANK, CALCULATION_TYPE_HORIZONTAL_TANK, CALCULATION_TYPE_RECTANGULAR_TANK, CALCULATION_TOP_LAYERS, CALCULATION_SIDE_LAYERS, CALCULATION_BOTTOM_LAYERS } from '../modules/calculation';

const stylesheet = {
  base: {

  },
  text: {
    paddingRight: 5 + 'px',
    paddingTop: 3 + 'px',
    paddingBottom: 3 + 'px',
    fontSize: 11 + 'px',
    color: '#D20000',
    animationDuration: 0.5 + 's',
    margin: 0 + 'px',
    fontWeight: 'bold',
  },
  hidden: {
    display: 'none'
  }
};

class Results extends Component {

  constructor(props) {
    super(props);
  }

  isPipeOrDuctReady = (type, section) => {
    if (type === CALCULATION_TYPE_PIPE) {
      return (section.length > 0);
    }
    if (type === CALCULATION_TYPE_CIRCULAR_DUCT || type === CALCULATION_TYPE_RECTANGULAR_DUCT) {
      return ( (section.length > 0) && (section.flowRate > 0) );
    }
  }
  render() {
    const {results, calculation, app, settings, translations, sectionChange, faceChange, createPDF } = this.props;

    const calculationObject = calculation ? calculation : {};
    let type = calculationObject.type;
    const {
      calculateTemperatureChange,
      calculateEnergyConsumption,
      calculateEndTemperature,
      sections,
      sectionIndex,
    } = calculationObject ? calculationObject : {};

    const section = sections ? sections[sectionIndex] : {};
    const {
      calculateFreezing,
      calculateAdapters,
      freezingPercentage,
      selectedLayers,
    } = section;

    if(type === CALCULATION_TYPE_DUCT) {
      type = section.type;
    }

    const {
      heatloss,
      surfaceTemperature,
      uninsulatedHeatLoss,
      uninsulatedSurfaceTemperature,
      heatLossPerSqrM,
      unisulatedHeatLossPerSqrM,

      totalAdaptersHeatloss,

      dewPoint,

      coolingTime,

      annualSavingsKwh,
      annualSavings,
      coEmissionReduction,
      totalAnnualSavingsKwh,
      totalAnnualSavings,
      totalCOemissionReduction,
      totalAdaptersAnnualSavings,
      totalUninsulatedAdaptersHeatloss,

      sectionResults,

      finalPipelineTemperature,
      totalPipelineHeatLoss,
      totalUninsulatedPipelineHeatLoss,
    } = results ? results : {};

    // TODO: type pitää localisoida
    if(!sectionResults ) {
      return (<div></div>);
    }

    let header;
    let lineHeader;
    if(type === CALCULATION_TYPE_PLANE) {
      header = getUIText('RESULT-RESULTS_FOR_FLAT_SURFACE', app.language, translations);
    } else if (type === CALCULATION_TYPE_PIPE) {
      header = getUIText('RESULT-RESULTS_FOR_PIPE', app.language, translations);
      lineHeader = getUIText('RESULT-RESULTS_FOR_PIPELINE', app.language, translations);
    } else if (type === CALCULATION_TYPE_CIRCULAR_DUCT || type === CALCULATION_TYPE_RECTANGULAR_DUCT) {
      header = getUIText('RESULT-RESULTS_FOR_DUCT', app.language, translations);
      lineHeader = getUIText('RESULT-RESULTS_FOR_DUCTLINE', app.language, translations);
    } else if (type === CALCULATION_TYPE_VERTICAL_TANK || type === CALCULATION_TYPE_HORIZONTAL_TANK || type === CALCULATION_TYPE_RECTANGULAR_TANK) {
      header = getUIText('RESULT-RESULTS_FOR_TANK', app.language, translations);
    }

    let resultBarResults = [];

    let resultMainContent;

/** ****************************************************************
**
**               PIPES AND DUCTS WITH MORE THAN ONE SECTION
**
******************************************************************/
    if((type == CALCULATION_TYPE_PIPE || type == CALCULATION_TYPE_CIRCULAR_DUCT || type == CALCULATION_TYPE_RECTANGULAR_DUCT) && sections.length > 1) {
      resultBarResults.push({topic: getUIText('RESULT-TOTAL_HEAT_LOSS', app.language, translations), value: formatDecimalsW(numeral(totalPipelineHeatLoss).format('0.0')), unit: ''});

      resultMainContent = (
        <tbody>
          <tr>
            <td className="topic">{getUIText('RESULT-TOTAL_HEAT_LOSS', app.language, translations)}</td>
            <td className="value">{formatDecimalsW(numeral(totalPipelineHeatLoss).format('0.0'))}</td>
          </tr>
          <tr>
            <td className="topic">{getUIText('RESULT-TOTAL_UNINSTALLED_HEAT_LOSS', app.language, translations)}</td>
            <td className="value">{formatDecimalsW(numeral(totalUninsulatedPipelineHeatLoss).format('0.0'))}</td>
          </tr>

          <tr>
            <td className="topic">{getUIText('RESULT-FINAL_TEMP_OF_CONTENTS', app.language, translations)}</td>
            <td className="value">{numeral(finalPipelineTemperature).format('0.0')} °C</td>
          </tr>

          { calculateAdapters ? (
            <tr>
              <td className="topic">{getUIText('RESULT-TOTAL_ADAPTERS_HEATLOSS', app.language, translations)}</td>
              <td className="value">{formatDecimalsW(numeral(totalAdaptersHeatloss).format('0.0'))}</td>
            </tr>) : null
          }

          { calculateAdapters ? (
            <tr>
              <td className="topic">{getUIText('RESULT-TOTAL_HEATLOSS_WITH_ADAPTERS', app.language, translations)}</td>
              <td className="value">{formatDecimalsW(numeral( (totalAdaptersHeatloss + totalPipelineHeatLoss) ).format('0.0'))} </td>
            </tr>) : null
          }

          { calculateEnergyConsumption ? (
            <tr>
              <td className="topic">{getUIText('RESULT-ANNUAL_SAVINGS', app.language, translations)}</td>
              <td className="value">{numeral(totalAnnualSavingsKwh).format('0.0')} kWh, {numeral(totalAnnualSavings).format('0.0')} {getUIText('COSTS-RESULT_CURRENCY', app.language, translations)}</td>
            </tr>) : null
          }

          { calculateEnergyConsumption ? (
          <tr>
            <td className="topic">{getUIText('RESULT-CO2_EMISSIONS', app.language, translations)}</td>
            <td className="value">{numeral(totalCOemissionReduction).format('0.0')} {getUIText('COSTS-RESULT_CO2', app.language, translations)}</td>
          </tr>) : null
          }

          { (calculateEnergyConsumption && totalUninsulatedAdaptersHeatloss && totalUninsulatedAdaptersHeatloss !== null) ? (
            <tr>
              <td className="topic">{getUIText('RESULT-ANNUAL_SAVINGS_ADAPTERS', app.language, translations)}</td>
              <td className="value">{numeral(totalAdaptersAnnualSavings).format('0.0')} {getUIText('COSTS-RESULT_CURRENCY', app.language, translations)}</td>
            </tr>) : null
          }

        </tbody>
      );


/** ****************************************************************
**
**               PIPES AND DUCTS WITH ONE SECTION
**
******************************************************************/
    } else if( (type == CALCULATION_TYPE_PIPE || type == CALCULATION_TYPE_CIRCULAR_DUCT || type == CALCULATION_TYPE_RECTANGULAR_DUCT) && sections.length < 2) {
      if(sections[0].heatlossUnitType == 'm') {
        resultBarResults.push(
          {
            topic: getUIText('RESULT-HEAT_LOSS', app.language, translations),
            value: ( (this.isPipeOrDuctReady(type, section)) ? formatDecimalsWperLength(numeral(sectionResults[0].heatloss).format('0.0')) : '-' ),
            unit: ''
          }
        );
      } else {
        resultBarResults.push(
          {
            topic: getUIText('RESULT-HEAT_LOSS', app.language, translations),
            value: ( (this.isPipeOrDuctReady(type, section)) ? formatDecimalsWperArea(numeral(sectionResults[0].heatlossArea).format('0.0')) : '-' ),
            unit: ''
          }
        );
      }

      resultBarResults.push(
        {
          topic: getUIText('RESULT-SURFACE_TEMPERATURE', app.language, translations),
          value: ( (this.isPipeOrDuctReady(type, section)) ? numeral(sectionResults[0].surfaceTemperature).format('0.0') : '-'),
          unit: '°C'
        },
        {
          topic: getUIText('RESULT-DEW_POINT', app.language, translations),
          value: ( (this.isPipeOrDuctReady(type, section)) ? numeral(sectionResults[0].dewPoint).format('0.0') : '-'),
          unit: '°C'
        },
      );

      if(calculateTemperatureChange) {
        if(sectionResults[0].temperatureDrop == '-') {
          resultBarResults.push(
            {topic: getUIText('RESULT-TEMPERATURE_CHANGE', app.language, translations), value: sectionResults[0].temperatureDrop, unit: '°C'},
          );
        } else {
          resultBarResults.push(
            {
              topic: getUIText('RESULT-TEMPERATURE_CHANGE', app.language, translations),
              value: ( (this.isPipeOrDuctReady(type, section)) ? numeral(sectionResults[0].temperatureDrop).format('0.0') : '-'),
              unit: '°C'
            },
          );
        }
      }

      if(calculateFreezing) {
        if(sectionResults[0].freezingTimeToValue == '-') {
          resultBarResults.push(
            {topic: (getUIText('RESULT-FROZEN_AT', app.language, translations) + ' ' + freezingPercentage + '%'), value: sectionResults[0].freezingTimeToValue, unit: 'h'},
          );
        } else {
          resultBarResults.push(
            {topic: (getUIText('RESULT-FROZEN_AT', app.language, translations) + ' ' + freezingPercentage + '%'), value: numeral(sectionResults[0].freezingTimeToValue).format('0.0'), unit: 'h'},
          );
        }
      }

      if(calculateEndTemperature) {
        resultBarResults.push(
          {topic: getUIText('RESULT-COOLING_TIME', app.language, translations), value: numeral(sectionResults[0].coolingTime).format('0.0'), unit: 'h'},
        );
      }

      if(calculateAdapters) {
        resultBarResults.push(
          {topic: getUIText('RESULT-TOTAL_ADAPTERS_HEATLOSS', app.language, translations), value: formatDecimalsW(numeral(totalAdaptersHeatloss).format('0.0')), unit: ''},
        );
      }


      /** ****************************************************************
      **
      **               TOTAL VALUES FOR PIPELINE/DUCTLINE
      **
      ******************************************************************/

      resultMainContent = (
        <tbody>
          { (sections[0].heatlossUnitType == 'm') ?
            (
              <tr>
                <td className="topic">{getUIText('RESULT-HEAT_LOSS', app.language, translations)}</td>
                <td className="value">
                  {(this.isPipeOrDuctReady(type, section)) ? formatDecimalsWperLength(numeral(sectionResults[0].heatloss).format('0.0')) : '-'}
                </td>
              </tr>
            ) : (
              <tr>
                <td className="topic">{getUIText('RESULT-HEAT_LOSS', app.language, translations)}</td>
                <td className="value">
                  {(this.isPipeOrDuctReady(type, section)) ? formatDecimalsWperArea(numeral(sectionResults[0].heatlossArea).format('0.0')) : '-'}
                </td>
              </tr>
            )
          }
          { (sections[0].heatlossUnitType == 'm') ?
            (
            <tr>
              <td className="topic">{getUIText('RESULT-UNINSTALLED_HEAT_LOSS', app.language, translations)}</td>
                <td className="value">
                  {(this.isPipeOrDuctReady(type, section)) ? formatDecimalsWperLength(numeral(sectionResults[0].uninsulatedHeatLoss).format('0.0')) : '-'}
                </td>
            </tr>
           ) : (
            <tr>
              <td className="topic">{getUIText('RESULT-UNINSTALLED_HEAT_LOSS', app.language, translations)}</td>
                <td className="value">
                  {(this.isPipeOrDuctReady(type, section)) ? formatDecimalsWperArea(numeral(sectionResults[0].uninsulatedHeatLossArea).format('0.0')) : '-'}
                </td>
            </tr>
          )
          }

          {(sectionResults[0].uKlasse && this.isPipeOrDuctReady(type, section)) ?
            <tr>
              <td className="topic">{getUIText('CALCULATION-TARGET-UVALUE', app.language, translations)}</td>
              <td className="value">{numeral(sectionResults[0].uKlasse).format('0.00')} {sectionResults[0].uKlasseUnit}</td>
            </tr>
          : null}

          {(sectionResults[0].uKlasseNorm && this.isPipeOrDuctReady(type, section)) ?
            <tr>
              <td className="topic">{getUIText('CALCULATION-TARGET-KLASSE-UVALUE', app.language, translations)}</td>
              <td className="value">{numeral(sectionResults[0].uKlasseNorm).format('0.00')} {sectionResults[0].uKlasseUnit}</td>
            </tr>
          : null}

          { (calculateAdapters && this.isPipeOrDuctReady(type, section)) ? (
            <tr>
              <td className="topic">{getUIText('RESULT-TOTAL_ADAPTERS_HEATLOSS', app.language, translations)}</td>
              <td className="value">{formatDecimalsW(numeral(totalAdaptersHeatloss).format('0.0'))}</td>
            </tr>) : null
          }

          { (calculateTemperatureChange && this.isPipeOrDuctReady(type, section)) &&
            <tr>
              <td className="topic">{getUIText('RESULT-TOTAL_HEAT_LOSS', app.language, translations)}</td>
              <td className="value">{formatDecimalsW(numeral(totalPipelineHeatLoss).format('0.0'))}</td>
            </tr>
          }
          { (calculateTemperatureChange && this.isPipeOrDuctReady(type, section)) &&
            <tr>
              <td className="topic">{getUIText('RESULT-TOTAL_UNINSTALLED_HEAT_LOSS', app.language, translations)}</td>
              <td className="value">{formatDecimalsW(numeral(totalUninsulatedPipelineHeatLoss).format('0.0'))}</td>
            </tr>
          }

          <tr>
            <td className="topic">{getUIText('RESULT-SURFACE_TEMPERATURE', app.language, translations)}</td>
            <td className="value">
              { (this.isPipeOrDuctReady(type, section)) ? numeral(sectionResults[0].surfaceTemperature).format('0.0') : '-'} °C
            </td>
          </tr>
          <tr>
            <td className="topic">{getUIText('RESULT-UNINSULATED_SURFACE_TEMPERATURE', app.language, translations)}</td>
            <td className="value">
              {(this.isPipeOrDuctReady(type, section)) ? numeral(sectionResults[0].uninsulatedSurfaceTemperature).format('0.0') : '-'} °C
            </td>
          </tr>
          <tr>
            <td className="topic">{getUIText('RESULT-DEW_POINT', app.language, translations)}</td>
            <td className="value">
              {(this.isPipeOrDuctReady(type, section)) ? numeral(sectionResults[0].dewPoint).format('0.0') : '-'} °C
            </td>
          </tr>

          { calculateTemperatureChange ? (


            <tr>
              <td className="topic">{getUIText('RESULT-TEMPERATURE_CHANGE', app.language, translations)}</td>
              {sectionResults[0].temperatureDrop == '-' ? (
              <td className="value">{sectionResults[0].temperatureDrop} °C</td>
              ) : (
                  <td className="value">
                    {(this.isPipeOrDuctReady(type, section)) ? numeral(sectionResults[0].temperatureDrop).format('0.0') : '-'} °C
                  </td>
              )}
            </tr>) : null
          }

          { (calculateFreezing && this.isPipeOrDuctReady(type, section)) ? (
            <tr>
              <td className="topic">{getUIText('RESULT-FREEZING_STARTS', app.language, translations)}</td>
              {sectionResults[0].freezingTime == '-' ? (
              <td className="value">{sectionResults[0].freezingTime} h</td>
              ) : (
              <td className="value">{numeral(sectionResults[0].freezingTime).format('0.0')} h</td>
              )}
            </tr>) : null
          }
          { (calculateFreezing && this.isPipeOrDuctReady(type, section)) ? (
            <tr>
              <td className="topic">{getUIText('RESULT-FROZEN_AT', app.language, translations) + ' ' + freezingPercentage + '%'}</td>
              {sectionResults[0].freezingTimeToValue == '-' ? (
              <td className="value">{sectionResults[0].freezingTimeToValue} h</td>
              ) : (
              <td className="value">{numeral(sectionResults[0].freezingTimeToValue).format('0.0')} h</td>
              )}
            </tr>) : null
          }
          { (calculateFreezing && sectionResults[0].freezingResistance >= 0 && this.isPipeOrDuctReady(type, section)) ? (
            <tr>
              <td className="topic">{getUIText('RESULT-HEATING_CABLE_WATTAGE', app.language, translations)}</td>
              {sectionResults[0].freezingResistance == '-' ? (
              <td className="value">{formatDecimalsWperLength(sectionResults[0].freezingResistance)}</td>
              ) : (
              <td className="value">{formatDecimalsWperLength(numeral(sectionResults[0].freezingResistance).format('0.0'))}</td>
              )}
            </tr>) : null
          }

          <tr>
            <td className="topic">{getUIText('RESULT-NOMINAL_WEIGHT', app.language, translations)}</td>
            <td className="value">{numeral(sectionResults[0].nominalWeight).format('0.0')} kg/m</td>
          </tr>

          { (calculateEnergyConsumption && this.isPipeOrDuctReady(type, section) ) ? (
            <tr>
              <td className="topic">{getUIText('RESULT-ANNUAL_SAVINGS', app.language, translations)}</td>
              <td className="value">{numeral(sectionResults[0].annualSavingsKwh).format('0.0')} kWh, {numeral(sectionResults[0].annualSavings).format('0.0')} {getUIText('COSTS-RESULT_CURRENCY', app.language, translations)}</td>
            </tr>) : null
          }

          { (calculateEnergyConsumption && this.isPipeOrDuctReady(type, section)) ? (
          <tr>
            <td className="topic">{getUIText('RESULT-CO2_EMISSIONS', app.language, translations)}</td>
            <td className="value">{numeral(sectionResults[0].coEmissionReduction).format('0.0')} {getUIText('COSTS-RESULT_CO2', app.language, translations)}</td>
          </tr>) : null
          }

          { (calculateEnergyConsumption && totalUninsulatedAdaptersHeatloss && totalUninsulatedAdaptersHeatloss !== null && this.isPipeOrDuctReady(type, section)) ? (
            <tr>
              <td className="topic">{getUIText('RESULT-ANNUAL_SAVINGS_ADAPTERS', app.language, translations)}</td>
              <td className="value">{numeral(totalAdaptersAnnualSavings).format('0.0')} {getUIText('COSTS-RESULT_CURRENCY', app.language, translations)}</td>
            </tr>) : null
          }

          { (calculateEndTemperature && this.isPipeOrDuctReady(type, section)) ? (
          <tr>
            <td className="topic">{getUIText('RESULT-COOLING_TIME', app.language, translations)}</td>
            <td className="value">{numeral(sectionResults[0].coolingTime).format('0.0')} h</td>
          </tr>) : null
          }
        </tbody>
      );

/** ****************************************************************
**
**               PLANES
**
******************************************************************/
    } else if( type == CALCULATION_TYPE_PLANE) {
      resultBarResults.push(
        {topic: getUIText('RESULT-HEAT_LOSS', app.language, translations), value: formatDecimalsWperArea(numeral(sectionResults[0].heatloss).format('0.0')), unit: ''},
        {topic: getUIText('RESULT-TOTAL_HEAT_LOSS', app.language, translations), value: formatDecimalsW(numeral(heatloss).format('0.0')), unit: ''},
        {topic: getUIText('RESULT-SURFACE_TEMPERATURE', app.language, translations), value: numeral(sectionResults[0].surfaceTemperature).format('0.0'), unit: '°C'},
      );

      resultMainContent = (
        <tbody>
          <tr>
            <td className="topic">{getUIText('RESULT-HEAT_LOSS', app.language, translations)}</td>
            <td className="value">{formatDecimalsWperArea(numeral(sectionResults[0].heatloss).format('0.0'))}</td>
          </tr>
          <tr>
            <td className="topic">{getUIText('RESULT-UNINSTALLED_HEAT_LOSS', app.language, translations)}</td>
            <td className="value">{formatDecimalsWperArea(numeral(sectionResults[0].uninsulatedHeatLoss).format('0.0'))}</td>
          </tr>
          <tr>
            <td className="topic">{getUIText('RESULT-TOTAL_HEAT_LOSS', app.language, translations)}</td>
            <td className="value">{formatDecimalsW(numeral(heatloss).format('0.0'))}</td>
          </tr>
          <tr>
            <td className="topic">{getUIText('RESULT-TOTAL_UNINSTALLED_HEAT_LOSS', app.language, translations)}</td>
            <td className="value">{formatDecimalsW(numeral(uninsulatedHeatLoss).format('0.0'))}</td>
          </tr>

          { sectionResults[0].uKlasse ?
            <tr>
              <td className="topic">{getUIText('CALCULATION-TARGET-UVALUE', app.language, translations)}</td>
              <td className="value">{numeral(sectionResults[0].uKlasse).format('0.00')} {sectionResults[0].uKlasseUnit}</td>
            </tr>
          : null}

          { sectionResults[0].uKlasseNorm ?
            <tr>
              <td className="topic">{getUIText('CALCULATION-TARGET-KLASSE-UVALUE', app.language, translations)}</td>
              <td className="value">{numeral(sectionResults[0].uKlasseNorm).format('0.00')} {sectionResults[0].uKlasseUnit}</td>
            </tr>
          : null}

          <tr>
            <td className="topic">{getUIText('RESULT-SURFACE_TEMPERATURE', app.language, translations)}</td>
            <td className="value">{numeral(sectionResults[0].surfaceTemperature).format('0.0')} °C</td>
          </tr>
          <tr>
            <td className="topic">{getUIText('RESULT-UNINSULATED_SURFACE_TEMPERATURE', app.language, translations)}</td>
            <td className="value">{numeral(sectionResults[0].uninsulatedSurfaceTemperature).format('0.0')} °C</td>
          </tr>
          <tr>
            <td className="topic">{getUIText('RESULT-DEW_POINT', app.language, translations)}</td>
            <td className="value">{numeral(sectionResults[0].dewPoint).format('0.0')} °C</td>
          </tr>
          <tr>
            <td className="topic">{getUIText('RESULT-NOMINAL_WEIGHT', app.language, translations)}</td>
            <td className="value">{numeral(sectionResults[0].nominalWeight).format('0.0')} kg/m²</td>
          </tr>

          { calculateEnergyConsumption ? (
            <tr>
              <td className="topic">{getUIText('RESULT-ANNUAL_SAVINGS', app.language, translations)}</td>
              <td className="value">{numeral(sectionResults[0].annualSavingsKwh).format('0.0')} kWh, {numeral(sectionResults[0].annualSavings).format('0.0')} {getUIText('COSTS-RESULT_CURRENCY', app.language, translations)}</td>
            </tr>) : null
          }

          { calculateEnergyConsumption ? (
          <tr>
            <td className="topic">{getUIText('RESULT-CO2_EMISSIONS', app.language, translations)}</td>
            <td className="value">{numeral(sectionResults[0].coEmissionReduction).format('0.0')} {getUIText('COSTS-RESULT_CO2', app.language, translations)}</td>
          </tr>) : null
          }


        </tbody>
      );

/** ****************************************************************
**
**               TANKS
**
******************************************************************/
    } else if( type === CALCULATION_TYPE_VERTICAL_TANK || type === CALCULATION_TYPE_HORIZONTAL_TANK || type === CALCULATION_TYPE_RECTANGULAR_TANK) {
      resultBarResults.push(
        {topic: getUIText('RESULT-HEAT_LOSS', app.language, translations), value: formatDecimalsWperArea(numeral(heatLossPerSqrM).format('0.0')), unit: ''},
      );

      resultBarResults.push(
        {topic: getUIText('RESULT-TOTAL_HEAT_LOSS', app.language, translations), value: formatDecimalsW(numeral(heatloss).format('0.0')), unit: ''},
      );

      if(calculateEndTemperature) {
        resultBarResults.push(
          {topic: getUIText('RESULT-COOLING_TIME', app.language, translations), value: numeral(coolingTime).format('0.0'), unit: 'h'},
        );
      }


      /** ****************************************************************
      **
      **               TOTAL VALUES FOR TANK
      **
      ******************************************************************/
      resultMainContent = (
        <tbody>


          <tr>
            <td className="topic">{getUIText('RESULT-HEAT_LOSS', app.language, translations)}</td>
            <td className="value">{formatDecimalsWperArea(numeral( heatLossPerSqrM).format('0.0'))}</td>
          </tr>
          <tr>
            <td className="topic">{getUIText('RESULT-UNINSTALLED_HEAT_LOSS', app.language, translations)}</td>
            <td className="value">{formatDecimalsWperArea(numeral( unisulatedHeatLossPerSqrM).format('0.0'))}</td>
          </tr>

          <tr>
            <td className="topic">{getUIText('RESULT-TOTAL_HEAT_LOSS', app.language, translations)}</td>
            <td className="value">{formatDecimalsW(numeral(heatloss).format('0.0'))}</td>
          </tr>
          <tr>
            <td className="topic">{getUIText('RESULT-TOTAL_UNINSTALLED_HEAT_LOSS', app.language, translations)}</td>
            <td className="value">{formatDecimalsW(numeral(uninsulatedHeatLoss).format('0.0'))}</td>
          </tr>

          { (sectionResults[sectionIndex].topLayers.uKlasse && type === CALCULATION_TYPE_HORIZONTAL_TANK) ?
            <tr>
              <td className="topic">{getUIText('CALCULATION-TARGET-UVALUE', app.language, translations)}</td>
              <td className="value">{numeral(sectionResults[sectionIndex].topLayers.uKlasse).format('0.00')} {sectionResults[sectionIndex].topLayers.uKlasseUnit}</td>
            </tr>
          : null}

          { (sectionResults[sectionIndex].topLayers.uKlasseNorm && type === CALCULATION_TYPE_HORIZONTAL_TANK) ?
            <tr>
              <td className="topic">{getUIText('CALCULATION-TARGET-KLASSE-UVALUE', app.language, translations)}</td>
              <td className="value">{numeral(sectionResults[sectionIndex].topLayers.uKlasseNorm).format('0.00')} {sectionResults[sectionIndex].topLayers.uKlasseUnit}</td>
            </tr>
          : null}

          {(type === CALCULATION_TYPE_HORIZONTAL_TANK) ? (
              <tr>
                <td className="topic">{getUIText('RESULT-SURFACE_TEMPERATURE', app.language, translations)}</td>
                <td className="value">{numeral(sectionResults[sectionIndex].topLayers.surfaceTemperature).format('0.0')} °C</td>
              </tr>
            ) : null}

          {(type === CALCULATION_TYPE_HORIZONTAL_TANK) ? (
              <tr>
                <td className="topic">{getUIText('RESULT-DEW_POINT', app.language, translations)}</td>
                <td className="value">{numeral(sectionResults[sectionIndex].topLayers.dewPoint).format('0.0')} °C</td>
              </tr>
            ) : null}

          {(type === CALCULATION_TYPE_HORIZONTAL_TANK) ? (
              <tr>
                <td className="topic">{getUIText('RESULT-NOMINAL_WEIGHT', app.language, translations)}</td>
                <td className="value">{numeral(sectionResults[sectionIndex].topLayers.nominalWeight).format('0.0')} kg/m²</td>
              </tr>
          ) : null}


          {calculateEndTemperature ? (
            <tr>
              <td className="topic">{getUIText('RESULT-COOLING_TIME', app.language, translations)}</td>
              <td className="value">{numeral(coolingTime).format('0.0')} h</td>
            </tr>
          ) : null}

          { calculateEnergyConsumption ? (
            <tr>
              <td className="topic">{getUIText('RESULT-ANNUAL_SAVINGS', app.language, translations)}</td>
              <td className="value">{numeral(annualSavingsKwh).format('0.0')} kWh, {numeral(annualSavings).format('0.0')} {getUIText('COSTS-RESULT_CURRENCY', app.language, translations)}</td>
            </tr>) : null
          }

          { calculateEnergyConsumption ? (
          <tr>
            <td className="topic">{getUIText('RESULT-CO2_EMISSIONS', app.language, translations)}</td>
            <td className="value">{numeral(coEmissionReduction).format('0.0')} {getUIText('COSTS-RESULT_CO2', app.language, translations)}</td>
          </tr>) : null
          }


        </tbody>
      );
    }

    let sectionsList;
    if(sections) {
      sectionsList = sections.map( (item, index) => {
        return {name: header + ' ' + getUIText('PDF-SECTION', app.language, translations) + ' ' + (index + 1) + ', ' + item.length + 'm', id: index};
      });
    }

    let sectionResultsValues;

/** ****************************************************************
**
**               PIPES AND DUCTS WITH MORE THAN ONE SECTION
**               - results for selected section
**
******************************************************************/
    if (calculateTemperatureChange && sections.length > 1) {
      if(sections[sectionIndex].heatlossUnitType == 'm') {
        resultBarResults.push(
          {topic: getUIText('RESULT-HEAT_LOSS', app.language, translations), value: formatDecimalsWperLength(numeral(sectionResults[sectionIndex].heatloss).format('0.0')), unit: ''}
        );
      } else {
        resultBarResults.push(
          {topic: getUIText('RESULT-HEAT_LOSS', app.language, translations), value: formatDecimalsWperArea(numeral(sectionResults[sectionIndex].heatlossArea).format('0.0')), unit: ''}
        );
      }
        resultBarResults.push(
          {topic: getUIText('RESULT-HEAT_LOSS', app.language, translations), value: numeral(sectionResults[sectionIndex].heatloss).format('0.0'), unit: 'W/m'},
          {topic: getUIText('RESULT-SURFACE_TEMPERATURE', app.language, translations), value: numeral(sectionResults[sectionIndex].surfaceTemperature).format('0.0'), unit: '°C'},
          {topic: getUIText('RESULT-DEW_POINT', app.language, translations), value: numeral(sectionResults[sectionIndex].dewPoint).format('0.0'), unit: '°C'},
        );

        if(calculateTemperatureChange) {
          if(sectionResults[0].temperatureDrop == '-') {
            resultBarResults.push(
              {topic: getUIText('RESULT-TEMPERATURE_CHANGE', app.language, translations), value: sectionResults[sectionIndex].temperatureDrop, unit: '°C'},
            );
          } else {
            resultBarResults.push(
              {topic: getUIText('RESULT-TEMPERATURE_CHANGE', app.language, translations), value: numeral(sectionResults[sectionIndex].temperatureDrop).format('0.0'), unit: '°C'},
            );
          }
        }

        if(calculateEndTemperature) {
          resultBarResults.push(
            {topic: getUIText('RESULT-COOLING_TIME', app.language, translations), value: numeral(sectionResults[sectionIndex].coolingTime).format('0.0'), unit: 'h'},
          );
        }

        sectionResultsValues = (<Grid item xs={12} md={6}>
          <div className="result">
            <table className="table result-table">
              <colgroup>
                <col className="results-col-label"/>
                <col className="results-col-value"/>
              </colgroup>
              <tbody>
                { (sections[sectionIndex].heatlossUnitType == 'm') ? (
                  <tr>
                    <td className="topic">{getUIText('RESULT-HEAT_LOSS', app.language, translations)}</td>
                    <td className="value">{formatDecimalsWperLength(numeral(sectionResults[sectionIndex].heatloss).format('0.0'))}</td>
                  </tr>
                ) : (
                  <tr>
                    <td className="topic">{getUIText('RESULT-HEAT_LOSS', app.language, translations)}</td>
                    <td className="value">{formatDecimalsWperArea(numeral(sectionResults[sectionIndex].heatlossArea).format('0.0'))}</td>
                  </tr>
                )}

                { (sections[sectionIndex].heatlossUnitType == 'm') ? (
                  <tr>
                    <td className="topic">{getUIText('RESULT-UNINSTALLED_HEAT_LOSS', app.language, translations)}</td>
                    <td className="value">{formatDecimalsWperLength(numeral(sectionResults[sectionIndex].uninsulatedHeatLoss).format('0.0'))}</td>
                  </tr>
                ) : (
                  <tr>
                    <td className="topic">{getUIText('RESULT-UNINSTALLED_HEAT_LOSS', app.language, translations)}</td>
                    <td className="value">{formatDecimalsWperArea(numeral(sectionResults[sectionIndex].uninsulatedHeatLossArea).format('0.0'))}</td>
                  </tr>
                )}

                {sectionResults[sectionIndex].uKlasse ?
                  <tr>
                    <td className="topic">{getUIText('CALCULATION-TARGET-UVALUE', app.language, translations)}</td>
                    <td className="value">{numeral(sectionResults[sectionIndex].uKlasse).format('0.00')} {sectionResults[sectionIndex].uKlasseUnit}</td>
                  </tr>
                : null}

                {sectionResults[sectionIndex].uKlasseNorm ?
                  <tr>
                    <td className="topic">{getUIText('CALCULATION-TARGET-KLASSE-UVALUE', app.language, translations)}</td>
                    <td className="value">{numeral(sectionResults[sectionIndex].uKlasseNorm).format('0.00')} {sectionResults[sectionIndex].uKlasseUnit}</td>
                  </tr>
                : null}

                <tr>
                  <td className="topic">{getUIText('RESULT-SURFACE_TEMPERATURE', app.language, translations)}</td>
                  <td className="value">{numeral(sectionResults[sectionIndex].surfaceTemperature).format('0.0')} °C</td>
                </tr>
                <tr>
                  <td className="topic">{getUIText('RESULT-UNINSULATED_SURFACE_TEMPERATURE', app.language, translations)}</td>
                  <td className="value">{numeral(sectionResults[sectionIndex].uninsulatedSurfaceTemperature).format('0.0')} °C</td>
                </tr>
                <tr>
                  <td className="topic">{getUIText('RESULT-DEW_POINT', app.language, translations)}</td>
                  <td className="value">{numeral(sectionResults[sectionIndex].dewPoint).format('0.0')} °C</td>
                </tr>
                <tr>
                  <td className="topic">{getUIText('RESULT-TEMPERATURE_CHANGE', app.language, translations)}</td>
                  {sectionResults[sectionIndex].temperatureDrop == '-' ? (
                  <td className="value">{sectionResults[sectionIndex].temperatureDrop} °C</td>
                  ) : (
                  <td className="value">{numeral(sectionResults[sectionIndex].temperatureDrop).format('0.0')} °C</td>
                  )}
                </tr>
                <tr>
                  <td className="topic">{getUIText('RESULT-NOMINAL_WEIGHT', app.language, translations)}</td>
                  <td className="value">{numeral(sectionResults[sectionIndex].nominalWeight).format('0.0')} kg/m</td>
                </tr>

                { calculateEnergyConsumption ? (
                  <tr>
                    <td className="topic">{getUIText('RESULT-ANNUAL_SAVINGS', app.language, translations)}</td>
                    <td className="value">{numeral(sectionResults[sectionIndex].annualSavingsKwh).format('0.0')} kWh, {numeral(sectionResults[sectionIndex].annualSavings).format('0.0')} {getUIText('COSTS-RESULT_CURRENCY', app.language, translations)}</td>
                  </tr>) : null
                }

                { calculateEnergyConsumption ? (
                <tr>
                  <td className="topic">{getUIText('RESULT-CO2_EMISSIONS', app.language, translations)}</td>
                  <td className="value">{numeral(sectionResults[sectionIndex].coEmissionReduction).format('0.0')} {getUIText('COSTS-RESULT_CO2', app.language, translations)}</td>
                </tr>) : null
                }

                { calculateEndTemperature ? (
                <tr>
                  <td className="topic">{getUIText('RESULT-COOLING_TIME', app.language, translations)}</td>
                  <td className="value">{numeral(sectionResults[sectionIndex].coolingTime).format('0.0')} h</td>
                </tr>) : null
                }

              </tbody>
            </table>
          </div>
        </Grid>);
    }

    let facesList, resultFace;
    if( type === CALCULATION_TYPE_VERTICAL_TANK || type === CALCULATION_TYPE_RECTANGULAR_TANK) {
      facesList = [
        {name: getUIText('RESULT-RESULTS_FOR_TOP_INSULATION', app.language, translations), id: CALCULATION_TOP_LAYERS},
        {name: getUIText('RESULT-RESULTS_FOR_SIDE_INSULATION', app.language, translations), id: CALCULATION_SIDE_LAYERS},
        {name: getUIText('RESULT-RESULTS_FOR_BOTTOM_INSULATION', app.language, translations), id: CALCULATION_BOTTOM_LAYERS},
      ];

      if(selectedLayers == CALCULATION_TOP_LAYERS) {
        resultFace = sectionResults[sectionIndex].topLayers;
      } else if(selectedLayers == CALCULATION_SIDE_LAYERS) {
        resultFace = sectionResults[sectionIndex].sideLayers;
      } else {
        resultFace = sectionResults[sectionIndex].bottomLayers;
      }
    }

    let tankSideResults;

/** ****************************************************************
**
**               TANKS
**               - results for selected side
**
******************************************************************/
     if(type === CALCULATION_TYPE_VERTICAL_TANK || type === CALCULATION_TYPE_RECTANGULAR_TANK) {
        resultBarResults.push(
          {topic: ' | ', value: '', unit: ''},
          {topic: getUIText('RESULT-HEAT_LOSS', app.language, translations), value: formatDecimalsWperArea(numeral(resultFace.heatloss).format('0.0')), unit: ''},
          {topic: getUIText('RESULT-SURFACE_TEMPERATURE', app.language, translations), value: numeral(resultFace.surfaceTemperature).format('0.0'), unit: '°C'},
        );

        tankSideResults = (<Grid item xs={12} md={6}>
          <div className="result">
            <table className="table result-table">
              <colgroup>
                <col className="results-col-label"/>
                <col className="results-col-value"/>
              </colgroup>
              <tbody>
              <tr>
                  <td className="topic">{getUIText('RESULT-HEAT_LOSS', app.language, translations)}</td>
                  <td className="value">{formatDecimalsWperArea(numeral(resultFace.heatloss).format('0.0'))}</td>
                </tr>
                <tr>
                  <td className="topic">{getUIText('RESULT-UNINSTALLED_HEAT_LOSS', app.language, translations)}</td>
                  <td className="value">{formatDecimalsWperArea(numeral(resultFace.uninsulatedHeatLoss).format('0.0'))}</td>
                </tr>

                {resultFace.uKlasse ?
                  <tr>
                    <td className="topic">{getUIText('CALCULATION-TARGET-UVALUE', app.language, translations)}</td>
                    <td className="value">{numeral(resultFace.uKlasse).format('0.00')} {resultFace.uKlasseUnit}</td>
                  </tr>
                : null}

                {resultFace.uKlasseNorm ?
                  <tr>
                    <td className="topic">{getUIText('CALCULATION-TARGET-KLASSE-UVALUE', app.language, translations)}</td>
                    <td className="value">{numeral(resultFace.uKlasseNorm).format('0.00')} {resultFace.uKlasseUnit}</td>
                  </tr>
                : null}

                <tr>
                  <td className="topic">{getUIText('RESULT-SURFACE_TEMPERATURE', app.language, translations)}</td>
                  <td className="value">{numeral(resultFace.surfaceTemperature).format('0.0')} °C</td>
                </tr>
                <tr>
                  <td className="topic">{getUIText('RESULT-DEW_POINT', app.language, translations)}</td>
                  <td className="value">{numeral(resultFace.dewPoint).format('0.0')} °C</td>
                </tr>
                <tr>
                  <td className="topic">{getUIText('RESULT-NOMINAL_WEIGHT', app.language, translations)}</td>
                  <td className="value">{numeral(resultFace.nominalWeight).format('0.0')} kg/m²</td>
                </tr>
                <tr>
                  <td className="topic">{getUIText('RESULT-UNINSULATED_SURFACE_TEMPERATURE', app.language, translations)}</td>
                  <td className="value">{numeral(resultFace.uninsulatedSurfaceTemperature).format('0.0')} °C</td>
                </tr>

                { calculateEnergyConsumption ? (
                  <tr>
                    <td className="topic">{getUIText('RESULT-ANNUAL_SAVINGS', app.language, translations)}</td>
                    <td className="value">{numeral(resultFace.annualSavingsKwh).format('0.0')} kWh, {numeral(resultFace.annualSavings).format('0.0')} {getUIText('COSTS-RESULT_CURRENCY', app.language, translations)}</td>
                  </tr>) : null
                }

                { calculateEnergyConsumption ? (
                <tr>
                  <td className="topic">{getUIText('RESULT-CO2_EMISSIONS', app.language, translations)}</td>
                  <td className="value">{numeral(resultFace.coEmissionReduction).format('0.0')} {getUIText('COSTS-RESULT_CO2', app.language, translations)}</td>
                </tr>) : null
                }

              </tbody>
            </table>
          </div>
        </Grid>);
    }

/** ****************************************************************
**
**               RESULTS PRINT OUT
**
******************************************************************/
    return (
      <Grid container spacing={3} alignContent="stretch" >
        <Grid className="header-section" item xs={12} md={6}>
          <div className="result-header">
            <h3>{(calculateTemperatureChange && sectionsList.length > 1) ? lineHeader : header }</h3>
          </div>
        </Grid>
        <Grid className="header-section" item xs={12} md={6}>
          {(calculateTemperatureChange && sectionsList.length > 1) ? <DropDownList className="result-dropdownlist" data={sectionsList} selectedItem={sectionIndex} onChange={(value) => {sectionChange(value);}} /> : null }
          {(type === CALCULATION_TYPE_VERTICAL_TANK || type === CALCULATION_TYPE_RECTANGULAR_TANK) ? <DropDownList className="result-dropdownlist" data={facesList} selectedItem={selectedLayers} onChange={(value) => {faceChange(value);}} /> : null }
        </Grid>
        <Grid item xs={12} md={(calculateTemperatureChange && sectionsList.length > 1) || (type === CALCULATION_TYPE_VERTICAL_TANK || type === CALCULATION_TYPE_RECTANGULAR_TANK) ? 6 : 12}>
          <div className="result">
            <table className="table result-table" >
              <colgroup>
                <col className="results-col-label"/>
                <col className="results-col-value"/>
              </colgroup>
                {resultMainContent}
            </table>
          </div>
        </Grid>
        {sectionResultsValues}
        {tankSideResults}
        <Button color="primary" className=""  onClick={createPDF} >
          <i className="fa fa-file-pdf-o mr-2"/>{getUIText('MENU-SAVE_AS_PDF', app.language, translations)}
        </Button>
        <ResultBar results={resultBarResults} />
      </Grid>
    );
  }
}

Results.propTypes = {
  results: PropTypes.any,
  calculation: PropTypes.any,
  app: PropTypes.any,
  settings: PropTypes.any,
  translations: PropTypes.any,
  sectionChange: PropTypes.any,
  faceChange: PropTypes.any,
  createPDF: PropTypes.any,
};

export default Results;
